import { render, staticRenderFns } from "./DataDiscoveryView.vue?vue&type=template&id=0fdb7906&"
import script from "./DataDiscoveryView.vue?vue&type=script&lang=js&"
export * from "./DataDiscoveryView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports